import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';
import { useSite } from '@/context/SiteContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_b3658f45-91a7-444d-afc2-1a3b5556caed/artifacts/3z2poj6e_logo.png';

export const Footer = () => {
  const { siteData } = useSite();

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-card pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Festa Encantada" 
              className="h-16 w-auto object-contain mb-4 brightness-110"
            />
            <p className="text-card/80 text-sm mb-4">
              {siteData?.slogan || 'Magia em cada detalhe da tua festa.'}
            </p>
            <div className="flex gap-4">
              <a 
                href={siteData?.socialLinks?.instagram || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-card/60 hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href={siteData?.socialLinks?.facebook || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-card/60 hover:text-primary transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href={siteData?.contact?.whatsappLink || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-card/60 hover:text-secondary transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-card mb-4">Loja</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/loja" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Todos os Produtos
                </Link>
              </li>
              <li>
                <Link to="/loja?filter=novidades" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Novidades
                </Link>
              </li>
              <li>
                <Link to="/loja?filter=mais-vendidos" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Mais Vendidos
                </Link>
              </li>
              <li>
                <Link to="/loja?categoria=kits" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Kits Festa
                </Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h4 className="font-semibold text-card mb-4">Informações</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/sobre-nos" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/trocas-devolucoes" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Trocas e Devoluções
                </Link>
              </li>
              <li>
                <Link to="/privacidade" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/termos" className="text-card/70 hover:text-primary text-sm transition-colors">
                  Termos e Condições
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-card mb-4">Contactos</h4>
            <ul className="space-y-3">
              <li className="text-card/70 text-sm">
                <span className="block text-card font-medium">WhatsApp:</span>
                <a 
                  href={siteData?.contact?.whatsappLink || '#'} 
                  className="hover:text-secondary transition-colors"
                >
                  {siteData?.contact?.whatsappDisplay || '+351 967 472 503'}
                </a>
              </li>
              <li className="text-card/70 text-sm">
                <span className="block text-card font-medium">Levantamento:</span>
                {siteData?.pickup?.name || 'Pastelaria Torrão Douro'}
                <br />
                <span className="text-xs">{siteData?.pickup?.fullAddress || 'R. Garcia de Resende 84A, 2755-048 Alcabideche (Cascais)'}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-card/10 pt-6 mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-card/60 text-sm">
              © {currentYear} Festa Encantada. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4 text-card/60 text-sm">
              <span>Portes: 5,00 € (Grátis a partir de 50,00 €)</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
